import libidoBelugaQuestion from './Initial/LibidoBeluga';

const libidoQuestions = [...libidoBelugaQuestion];

export default libidoQuestions;
